/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Visa(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Visa',
      'aria-hidden': true,
      focusable: false,
      width:  100 * scale,
      height: 60 * scale,
      viewBox: '0 0 100 60',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none"},createElement('rect', {"fill":"#26337A","width":"100","height":"60","rx":"4"}),createElement('path', {"fill":"#FFFFFE","d":"m41.49 39.547 3.075-19.074h4.915l-3.074 19.074zM64.233 20.94c-.972-.382-2.5-.8-4.404-.8-4.86 0-8.28 2.59-8.31 6.296-.03 2.742 2.44 4.27 4.3 5.182 1.91.934 2.56 1.532 2.55 2.367-.01 1.277-1.53 1.863-2.94 1.863-1.97 0-3.02-.288-4.63-1l-.64-.304-.69 4.27c1.14.53 3.27.992 5.47 1.017 5.16 0 8.52-2.55 8.56-6.51.01-2.17-1.3-3.82-4.13-5.18-1.72-.88-2.77-1.47-2.76-2.36 0-.79.89-1.64 2.81-1.64a8.6 8.6 0 0 1 3.68.73l.44.22.66-4.13m6.55 11.84a2639 2639 0 0 0 1.95-5.33l.65-1.82.33 1.65 1.13 5.51h-4.08zm6.07-12.3h-3.8c-1.18 0-2.06.34-2.58 1.58l-7.3 17.48h5.16s.84-2.35 1.03-2.86l6.29.01.6 2.86h4.57l-3.98-19.06zm-39.48 0-4.81 13-.52-2.64c-.9-3.04-3.69-6.34-6.81-8l4.4 16.68h5.2l7.74-19.04z"}),createElement('path', {"d":"M28.09 20.476h-7.925l-.065.395c6.167 1.58 10.248 5.4 11.94 9.98l-1.72-8.76c-.298-1.21-1.162-1.56-2.23-1.61","fill":"#EC982D"})))
}
